import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { singleSessionPerformersReselector, stagingRequestsReselector } from 'src/app/store/reselectors/performers.reselector';
import { Performer } from 'src/app/store/performers.era';
import { manageSessionStates, manageSessionPermissionReselector, ManageSessionStates } from 'src/app/store/reselectors/sessions.reselector';
import { generateEmailLink } from '../../helpers/helpers';
import { compactDate, jsonCopyObject, makeMapFromListOfObjectsAndKey } from 'globals/helpers/helpers';
import { SessionItemInfo, ItemStatus, ShareableItemTypes, SessionItemType } from 'globals/store/share.data';
import { eventsFeature, JoiEvent } from 'src/app/store/events.era';
import { SessionInfo } from 'src/app/store/reselectors/performerSponsors.reselector';
import { LabelUpdateFunctionParams } from 'src/app/components/label-marker/label-maker.dialog.component';
import { sessionTabs, EntityAsset, EntityRequest, SessionTabs } from 'globals/store/programs.data';
import { ManageWrapperComponent, TabGroup } from './manage-wrapper.component';
import { InformableSection } from 'globals/store/informables.data';
import { nonSpecificPerformerName } from 'globals/store/performers.data';
import { publicHelpers } from 'globals/helpers/public-helpers';
import { Wrapper } from 'src/app/components/wrapper.component';
import { JoiComment } from 'globals/store/tasks.data';
import { CueSheetDialogComponent, ManageCueSheetData } from '../cues/cue-sheet-dialog.component';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { Label } from 'globals/store/events.data';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { CommonModule } from '@angular/common';
import { ActionButtonComponent } from 'src/app/components/nav-bar/action-button.component';
import { InputEditorComponent } from 'src/app/components/joi-input/input-editor';
import { TitleIconComponent } from 'src/app/components/icon/title-icon.component';
import { AssetsComponent } from '../assets/assets.component';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';
import { FileHandlerComponent } from 'src/app/components/file-handler/file-handler.component';
import { SponsorsComponent } from '../sponsors/sponsors.component';
import { PerformersComponent } from 'src/app/components/performers/performers.component';
import { SessionTagPanelComponent } from '../logistics/session-tag-panel.component';
import { LogisticsSessionInlayComponent } from './logisitcs-inlay.component';
import { ChatBoxComponent } from './chat-box.component';
import { StagingRequestsComponent } from './staging-requests.component';
import { PerformerStagingRequestComponent } from 'src/app/components/performers/performerStagingRequestAdder.component';
import { EditableNotesComponent } from '../program/editable-notes.component';
import { SessionStatusComponent } from 'src/app/components/events/session-status.component';
import { TitleToggleComponent } from 'src/app/components/wrappers/title-toggle-wrapper.component';
import { PerformerSynopsisComponent } from 'src/app/components/performers/performerSynopsisAdder.component';
import { shareFeature } from 'src/app/store/share.era';
import { accountsFeature } from 'src/app/store/accounts.era';

@Component({
    selector: 'manage-session',
    templateUrl: './manage-session.html',
    styleUrls: ['./manage-dialogs.scss'],
    standalone: true,
    imports: [ManageWrapperComponent, TitleToggleComponent, PerformerSynopsisComponent, SessionStatusComponent, EditableNotesComponent, PerformerStagingRequestComponent, StagingRequestsComponent, ChatBoxComponent, LogisticsSessionInlayComponent, SessionTagPanelComponent, PerformersComponent, SponsorsComponent, FileHandlerComponent,  TipTextComponent, TitleIconComponent, AssetsComponent, IconComponent, CommonModule, ActionButtonComponent, InputEditorComponent,],
})
export class ManageSessionComponent extends Wrapper<ManageSessionComponent> implements  OnInit {
  _file = 'manage-session'
  labels: Label[] = []
  nonSpecificPerformerName = nonSpecificPerformerName;
  labelMap: { [id:string]: Label }
  readState: keyof ManageSessionStates = manageSessionStates.ReadOnly
  readStates = manageSessionStates
  showSessionSynopsisSelection:boolean
  asset: { [sesAndPerfId:string]: SessionItemInfo }
  stagingRequest: { [sesAndPerfId:string]: SessionItemInfo } = {}
  synopsis: { [id:string]: SessionItemInfo }
  stagingRequestInformables:InformableSection[] = [];
  event: JoiEvent
  performerMap:{[performerID:string]:Performer} = {}
  sessionInfo: SessionInfo
  tabs = sessionTabs
  tabGroups: TabGroup[] = [{ tabs: [
    { id: sessionTabs.info, name: 'Session info' },
    { id: sessionTabs.notes, name: 'Notes for performer brief' }, 
    { id: sessionTabs.assets, name: 'Session assets' },
    { id: sessionTabs.cues, name: 'Run of show' },
    { id: sessionTabs.facilitator, name: 'Facilitator notes' },
    { id: sessionTabs.stagingRequests, name: 'Staging requests' },
    { id: sessionTabs.quickNotes, name: 'Quick notes', icon: 'sticky18'}
  ]}, {
    groupName: 'LOGISTICS',
    tabs: [
      { id: sessionTabs.logistics, name: 'Staging' },
      { id: sessionTabs.catering, name: 'Catering' },
      { id: sessionTabs.tagging, name: 'Tagging' },
    ]
  }]
  selectedTab
  subscribedToTags = false
  stagingRequests: EntityRequest[]
  helpers = publicHelpers
  assetHint = `Note: Assets must be supplied through a file URL eg. Hosted on Dropbox or Google Drive. Individual file assets can’t be uploaded into Joi.\n\nOnce a submission is made the status will change from "Active" to "Submitted" and the link will be closed. To re-enable the link, change the status back to "Active".`

  constructor(
    public dialogRef: MatDialogRef<ManageSessionComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: ManageSessionData
  ) {
    super()
    if (data.openTab) {
      this.tabGroups.forEach(t => t.tabs.forEach(t => {
        if (t.id === data.openTab) this.selectedTab = t
      }))
    }
  }

  ngOnInit() {
    this.subCallback(this.store.select('events', 'labelMaps', 'session_labels'), labels => {
      this.labels = Object.values(labels)
      this.labelMap = labels
    })
    this.subProp(this.store.select(eventsFeature.selectEvent), 'event')
    this.subProp(this.store.select(manageSessionPermissionReselector), 'readState')
    this.subProp(this.store.select(shareFeature.selectAsset), 'asset')
    this.subProp(this.store.select(shareFeature.selectStagingRequest),'stagingRequest')

    this.subCallback(this.store.select(singleSessionPerformersReselector, this.data.sessionId), passedSessionInfo => { // The data is gotten through the reselector because it might be stale if passed from the table.  However, the save / cancel nature of the dialog and its subcomponents makes it pretty much necessary to only get one copy of the session on load, so first() is necessary here instead of a constant sub. <== replacing first() with an initial load boolean so we can pull off what stuff we need as it updates
      // console.log({ passedSessionInfo })
      if (!passedSessionInfo) return
      const sessionInfo = jsonCopyObject(passedSessionInfo)
      const { id, programId } = sessionInfo
      if (!this.subscribedToTags) {
        this.subscribedToTags = true
        this.subProp(this.store.select(stagingRequestsReselector, { sessionId: id, programId }), 'stagingRequests' )
        this.subCallback(this.store.select('shareables','synopsis'), data => {
          this.synopsis = data
          this.showSessionSynopsisSelection = data[sessionInfo.id] && data[sessionInfo.id].status !== 'Off'
        })
      }
      const { labels, presentationNotes, presentationAssets } = sessionInfo.fullSession
      this.performerMap = makeMapFromListOfObjectsAndKey( sessionInfo.performers, 'id');
      this.stagingRequestInformables = sessionInfo.fullSession.stagingRequests ? sessionInfo.fullSession.stagingRequests.map(r=>{
        return {title:r.by, items:[{name:r.by, description:r.requestText}]} as InformableSection
      }) : [];
      this.sessionInfo = sessionInfo
      this.sessionInfo.fullSession.labels = labels || []
      this.sessionInfo.fullSession.presentationNotes = presentationNotes || []
      this.sessionInfo.fullSession.presentationAssets = this.sessionInfo.fullSession.presentationAssets || []
      
    })
  }

  async editCueSheet() {
    const data: ManageCueSheetData = {
      sessionId: this.sessionInfo.id,
      programId: this.sessionInfo.programId,
      readOnly: this.readState !== manageSessionStates.Program && this.readState !== manageSessionStates.Logistics
    }
    await openDialogGetResult(this.dialog, CueSheetDialogComponent, { disableClose: true, autoFocus: false, data, panelClass: 'true-full-screen' })
  }

  toggleFlag(){
    this.sessionInfo.fullSession.flag = !this.sessionInfo.fullSession.flag;
    this.saveSession();
  }

  saveQuickNotes(quickNotes: JoiComment[]) {
    this.sessionInfo.fullSession.quickNotes = quickNotes
    this.saveSession()
  }

  addPublicLinks(event) {
    console.log({ event })
    this.sessionInfo.fullSession.publicLinks = event
    this.saveSession()
  }

  saveAssets(assets: EntityAsset[]) {
    this.sessionInfo.fullSession.presentationAssets = assets
    this.saveSession()
  }

  async toggleShowSessionSynopsisSelection(isOn){
    this.showSessionSynopsisSelection = isOn;
    if(this.synopsis[this.sessionInfo.id]){
      this.setSessionItemStatus(this.synopsis[this.sessionInfo.id].performerId, isOn ? 'Active' : 'Off', 'synopsis')
    } else if (isOn) this.setSessionItemStatus(null, 'Active', 'synopsis')
  }
  
  saveSession() {
    console.log("Saving session... ", jsonCopyObject(this.sessionInfo.fullSession))
    this.programService.updateSession(this.sessionInfo.programId, this.sessionInfo.fullSession)
  }

  updateSessionTitle(newTitle: string) {
    this.sessionInfo.fullSession.title = newTitle
    this.saveSession()
  }

  changeTab(tab) {
    this.selectedTab = tab
  }

  exit() {
    this.dialogRef.close()
  }

  synopsisEmailGenerator(publishCode: string) {
    const date = this.sessionInfo.date
    const dateText = date ? `, ${compactDate(new Date(date))}` : ''
    const title = this.event.title || 'untitled event'
    const subject = `Information required for ${title}${dateText}`
    const sessionName = this.sessionInfo.title || 'unnamed session'
    const body = `Hi there,\n\nCan you please provide details for ${sessionName} by completing the information in this link:\n\n${publishCode}\n\nThanks`
    return generateEmailLink(subject, body)
  }

  stagingEmailGenerator(publishCode: string) {
    const date = this.sessionInfo.date
    const dateText = date ? `, ${compactDate(new Date(date))}` : ''
    const title = this.event.title || 'untitled event'
    const subject = `Information required for ${title}${dateText}`
    const sessionName = this.sessionInfo.title || 'unnamed session'
    const body = `Hi there,\n\nCan you please click on the link below and submit any staging requests you have for ${sessionName}:\n\n${publishCode}\n\nThanks`
    return generateEmailLink(subject, body)
  }


  toggleShowInPublish(session: SessionInfo) {
    session.fullSession.hideInPublish = !session.fullSession.hideInPublish
    this.saveSession()
  }

  selectPerformerForSynopsis(performerId: string) {
    // const status:SessionItemStatus = synopsis && synopsis.status !== 'Off' ? synopsis.status : 'Active';
    this.setSessionItemStatus(performerId, 'Active', 'synopsis') // always active when choosing a new performer, can only be hit when on
  }

  setSessionItemStatus(performerId: string, status: ItemStatus, type: SessionItemType & keyof this) {
    if (!ShareableItemTypes[type]) return console.log("ADDING AN INVALID TYPE: " + type, { ShareableItemTypes: ShareableItemTypes })

    const performerName = performerId ? this.performerMap[performerId].name : '';
    const shareableId = `${this.sessionInfo.id}${ type === 'synopsis' ? '' : '_' + performerId }`
    const shareable = this[type][shareableId]
    
    if (!shareable) {
      this.shareBriefsService.addNewShareSessionItemView(this.sessionInfo.id, this.sessionInfo.programId, performerId || null, performerName, type)
      return;
    }
    // console.log({ shareable:shareable[type], performerId, status })
    const {id, key, sessionId, programId } = shareable
    const info: SessionItemInfo = { id, key, sessionId, programId, performerId: performerId || null, performerName, status }

    console.log({ shareable, shareableId, performerName, status, info, id })

    this.shareService.upsertShareInfo({ info }, id)
  }

  duplicate() {
    this.programService.duplicateSession(this.sessionInfo.programId, this.sessionInfo.fullSession)
    this.dialogRef.close()
  }


  delete() {
    this.programService.deleteSession(this.sessionInfo.programId, this.sessionInfo.fullSession)
    this.dialogRef.close()
  }

  public labelUpdateFunction({ labels, labelTemplate, labelsToggled, labelsChanged }: LabelUpdateFunctionParams) {
    if (labelsChanged) {
      this.eventService.updateEvent(this.eventService.eventId, { session_labels: labelTemplate })
    }
    if (labelsToggled) {
      this.sessionInfo.fullSession.labels = labels
      this.saveSession()
    }
  }

  addAssetIds(ids: string[]) {
    this.sessionInfo.fullSession.assetIds = [...(this.sessionInfo.fullSession.assetIds || []), ...ids]
    this.saveSession()
  }

  removeAssetId(idToRemove: string) {
    this.sessionInfo.fullSession.assetIds = this.sessionInfo.fullSession.assetIds.filter(id => id !== idToRemove)
    this.saveSession()
  }

  addPresentationAssetIds(ids: string[]) {
    const oldIds = this.sessionInfo.fullSession.presentationAssetIds || []
    this.sessionInfo.fullSession.presentationAssetIds = [...oldIds, ...ids]
    this.saveSession()
  }

  removePresentationAssetId(idToRemove: string) {
    this.sessionInfo.fullSession.presentationAssetIds = this.sessionInfo.fullSession.presentationAssetIds.filter(id => id !== idToRemove)
    this.saveSession()
  }

}

export interface ManageSessionData {
  sessionId: string
  openTab?: keyof SessionTabs
}
